import {
    Component,
    OnInit,
    Input,
    ElementRef,
    Inject,
    OnDestroy,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { fromEvent, merge } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ConfigService } from '@finder/core/config.service';
import { MultiSelectService } from '@finder/shared/services/multi-select/multi-select.service';
import { MultiSelectDirective } from '@finder/features/list/components/multi-select/multi-select.class';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { ModalService } from '@finder/shared/components/modal/modal.service';
import { MobileMultiSelectComponent } from '@finder/features/list/components/mobile-multi-select/mobile-multi-select.component';
import { ViewportDetectionService } from '@finder/shared/services/viewport-detection/viewport-detection.service';
import { FontIconComponent } from '@finder/shared/components/font-icon/font-icon.component';
import { RaCheckboxComponent } from '@finder/shared/components/ra-wrappers/ra-checkbox/ra-checkbox.component';

@Component({
    selector: 'finder-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: ['./multi-select.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FontIconComponent,
        RaCheckboxComponent,
    ]
})
export class MultiSelectComponent extends MultiSelectDirective implements OnInit, OnDestroy {
    @ViewChild('selectButton', { read: ElementRef }) selectButton: ElementRef;
    @Input() icon: string;
    @Input() disableOptions: boolean;
    @Input() set labels(labels: any) {
        this._labels = labels;
    }

    get labels() {
        return this._labels;
    }

    open = false;
    isMobile: boolean;
    mobileModal: ModalComponent;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private elementRef: ElementRef,
        private modalService: ModalService,
        private viewport: ViewportDetectionService,
        protected multiSelectService: MultiSelectService,
        protected configService: ConfigService,
    ) {
        super(multiSelectService, configService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.mobileModal = this.modalService.create(
            MobileMultiSelectComponent,
            {
                fullSize: true,
                title: this.labels.modalTitle,
                id: 'mobile-multi-select-modal',
                data: {
                    labels: this.labels
                }
            }
        );

        this.isMobile = this.viewport.isMobile();

        // Close the modal if the viewport change from mobile to desktop
        this.viewport.onViewportResize()
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.isMobile = this.viewport.isMobile();

                if (!this.isMobile && this.mobileModal.is('opened')) {
                    this.mobileModal.dismiss();
                }
            });

        merge(
            fromEvent(this.document, 'focusin'),
            fromEvent(this.document, 'click')
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe((event) => this.closeHandler(event));
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    onEscapeKey() {
        this.open = false;
        this.selectButton.nativeElement.focus();
    }

    closeHandler(event) {
        const parent = this.elementRef.nativeElement;
        const child = event.target;

        if (!parent.contains(child)) {
            // event outside the multi select dropdown
            // so close it.
            this.open = false;
        }
    }

    checkMobile() {
        if (this.viewport.isMobile()) {
            this.mobileModal.open();
        }
    }
}
